import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import '@/i18n/config';
import '@/styles/index.css';
import '../currency.config';
import '../logger.config';
import '../calendar.config';

const Wrapper = process.env.VITE_PUBLIC_ENV === 'development' ? React.StrictMode : React.Fragment;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Wrapper>
    <RouterProvider router={router} />
  </Wrapper>
);
